export const initialMockedState = {
  app: { locale: 'en', productCategory: 'wine' },
  remoteAccess: { data: { access_key: 'hashed_value', custom_id: 'mocked_custom_id', expiry: '2024', retries: 3 } },
  retailer: { data: { slug: 'retailer_slug' } },
  retailerLocation: { data: { identifier: 'RTL9999', slug: 'test' } },
  user: { role: 2 },
};
